import type { ScanInput } from './inputs';

type Translate = (key: string, values?: Record<string, unknown>) => string;

/** Message for a scan that is not what the current step expects. */
export function scanMismatchText(t: Translate, scan: ScanInput, expected: 'member' | 'product' | 'order'): string {
  if (scan.kind === 'invalid') {
    if (scan.reason === 'member_qr') return t('errors.invalid_member_qr');
    if (scan.reason === 'typo') return t('scan.typo');
    return t(`operator.scanInput.${scan.reason}`);
  }
  if (scan.kind === 'member_qr') return t('operator.scanInput.memberQrNotExpected');
  if (scan.kind === 'product') return t(expected === 'member' ? 'operator.scanInput.productNotExpectedMember' : 'operator.scanInput.productNotExpected');
  return t('operator.scanInput.orderNotExpected');
}
